<div class="p-5">
  <section class="mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex gap-2 align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-building"
          viewBox="0 0 16 16"
        >
          <path
            d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
          />
          <path
            d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"
          />
        </svg>
        <p class="mb-0 fw-semibold">Informations sur l'organisation</p>
      </div>
      <div
        class="d-flex gap-2 first-p primary-2"
        (click)="onUpdateStep(0)"
        role="button"
        tabindex="0"
      >
        <i-feather class="i-feather" name="edit2"></i-feather>
        <p class="mb-0">Modifier</p>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Numéro de SIRET</p>
        <p>{{ (monEntreprise && monEntreprise.siret) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">TVA intracommunautaire</p>
        <p>{{ (monEntreprise && monEntreprise.vatNumber) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Secteur d'activité</p>
        <p>{{ (monEntreprise && monEntreprise.industryType) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Forme juridique</p>
        <p>{{ (monEntreprise && monEntreprise.legalStatus) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Nom de l'organisation</p>
        <p>{{ (monEntreprise && monEntreprise.name) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Pays</p>
        <p>{{ (monEntreprise && monEntreprise.country) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Adresse</p>
        <p>{{ (monEntreprise && monEntreprise.address1) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Adresse 2</p>
        <p>{{ (monEntreprise && monEntreprise.address2) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Adresse 3</p>
        <p>{{ (monEntreprise && monEntreprise.address3) || "-" }}</p>
      </div>
      <div class="col-6 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Ville</p>
        <p>{{ (monEntreprise && monEntreprise.city) || "-" }}</p>
      </div>
      <div class="col-6 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Code Postal</p>
        <p>{{ (monEntreprise && monEntreprise.postalCode) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Numéro de téléphone</p>
        <p>{{ (monEntreprise && monEntreprise.phoneNumber) || "-" }}</p>
      </div>
    </div>
  </section>

  <section>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style="color: white"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-person-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
          />
        </svg>
        <p class="mb-0 fw-semibold">Vos informations</p>
      </div>
      <div
        class="d-flex gap-2 first-p primary-2"
        (click)="onUpdateStep(1)"
        role="button"
        tabindex="0"
      >
        <i-feather class="i-feather primary-2" name="edit2"></i-feather>
        <p class="mb-0">Modifier</p>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Identifiant utilisateur</p>
        <p>{{ (mesInformations && mesInformations.login) || "-" }}</p>
      </div>
      <div class="col-6 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Prénom</p>
        <p>{{ (mesInformations && mesInformations.firstname) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Nom</p>
        <p>{{ (mesInformations && mesInformations.lastname) || "-" }}</p>
      </div>
      <div class="col-12 d-flex flex-column align-items-start">
        <p class="mb-0 first-p primary-2">Email</p>
        <p>{{ (mesInformations && mesInformations.email) || "-" }}</p>
      </div>
    </div>
  </section>
</div>
